/**
 * What to send for a "Specific people" list (household sharing D2): people
 * already on it by id, anyone newly added by the exact name that was typed
 * (`via`) — the API never accepts a bare id for someone outside the
 * household.
 * @param {{id: number, username: string, via?: string}[]} people
 */
export function sharePayload(people) {
  return {
    shared_with_ids: people.filter((p) => !p.via).map((p) => p.id),
    share_with: people.filter((p) => p.via).map((p) => p.via),
  };
}
